import React, { useState } from 'react';
import { Input, Modal } from 'antd';
import { Button } from 'components/ui';
import { usePurgeRedisCache } from '../../../mutation/admin';

export default function RedisCacheInvalidation() {
  const [key, setKey] = useState('');
  const { isLoading, mutate } = usePurgeRedisCache();
  const onConfirm = () =>
    Modal.confirm({
      onOk: () => mutate(key),
      title: 'Confirmation',
      content: `Do you want to purge redis cache with the pattern ${key}?`,
    });
  return (
    <div>
      <div className="flex items-center space-x-2" style={{ width: 700 }}>
        <Input
          placeholder="Key or prefix"
          value={key}
          onChange={e => setKey(e.target.value)}
        />
        <Button disabled={!key} loading={isLoading} onClick={onConfirm}>
          Purge Cache
        </Button>
      </div>
    </div>
  );
}
